export const environment = {
  name: 'prod',
  production: true,
  //apiUrl: 'https://prd-dentalbidirectional-web.azurewebsites.net/api/App',
  //authUrl: 'https://prd-dentalbidirectional-web.azurewebsites.net/Auth',
  frontDoorAPIUri: 'https://dentalbidirectional.careoregon.org',
  sideDoorAPIUri: 'https://prd-dentalbidirectional-web.azurewebsites.net',
  healthTrioAuthUrl: 'https://careoregon.healthtrioconnect.com/app/index.page?locate=CareOregonDental',
  allowedOrigins: [
    'https://dentalbidirectional.careoregon.org',
    'https://prd-dentalbidirectional-web.azurewebsites.net'
  ],
  displayTimeZone: 'America/Los_Angeles'
};
